import { Outlet } from 'react-router-dom'
import { AdditionalUsers } from './modules/additionalUsers'
import { AccountAccess } from './modules/accountAccess'
import { ChangeEmail } from './modules/changeEmail'
import { ChangePassword } from './modules/changePassword'
import { DeleteAccount } from './modules/deleteAccount'
import { useState } from 'react'
import { useGetUserQuery } from 'containers/auth/queries'
import Button from 'components/Button'
import { useAddNewUserMutation } from './queries'
import toast from 'react-hot-toast'

function AddNewUser() {
    const [email, setEmail] = useState('')

    const { mutate, isLoading } = useAddNewUserMutation()

    return (
        <div>
            <h2>Add New User</h2>
            <input style={{ marginTop: 20, marginBottom: 10 }} value={email} onChange={(e) => setEmail(e.target.value)} />
            <Button
                onClick={() =>
                    mutate(
                        { email: email },
                        {
                            onSuccess: (res) => {
                                setEmail('')
                                toast.success(res.message)
                            }
                        }
                    )
                }
                loading={isLoading}
            >
                Add
            </Button>
        </div>
    )
}

export function Account() {
    const { data: userData } = useGetUserQuery()

    return (
        <div className='p-4'>
            <div className='flex flex-col gap-8'>
                <ChangeEmail />
                <ChangePassword />
                <AdditionalUsers />
                <AccountAccess />
                {userData?.user.email === 'jamiebower03@gmail.com' && <AddNewUser />}
                <DeleteAccount />
            </div>

            <Outlet />
        </div>
    )
}
